import { useEffect, useRef } from 'react';
import Phaser from 'phaser';
import { GameScene } from './GameScene';

let gameInstance: Phaser.Game | null = null;
export function getPhaserGame() { return gameInstance; }

export function PhaserGame() {
  const hostRef = useRef<HTMLDivElement | null>(null);
  const gameRef = useRef<Phaser.Game | null>(null);

  useEffect(() => {
    if (!hostRef.current || gameRef.current) return;
    try {
    gameRef.current = new Phaser.Game({
      type: Phaser.AUTO,
      parent: hostRef.current,
      backgroundColor: '#1e3a8a',
      scale: {
        mode: Phaser.Scale.RESIZE,
        autoCenter: Phaser.Scale.CENTER_BOTH,
        width: window.innerWidth,
        height: window.innerHeight,
      },
      render: {
        antialias: true,
        pixelArt: false,
      },
      scene: [GameScene],
      input: { activePointers: 3 },
      fps: { target: 60, forceSetTimeOut: false },
    });
    gameInstance = gameRef.current;
    } catch (e) {
      console.error('[Phaser] init failed', e);
    }
    return () => {
      gameRef.current?.destroy(true);
      gameRef.current = null;
      gameInstance = null;
    };
  }, []);

  // fixed 全螢幕，不受父層 transform: scale() 影響
  return (
    <div
      ref={hostRef}
      className="fixed inset-0 z-0"
      style={{ touchAction: 'none' }}
    />
  );
}
